$(document).ready(function () {
  // Hover Effect On Chevron Icon

  let w = $(window).width();
  function DesktopMenu() {
    if (w > 990) {
      $("details").hover(
        function () {
          $(this).parent().addClass("hovered");
          $(this).attr("open", "open");
          $(this).children("summary").attr("aria-expanded", "true");
        },
        function () {
          $(this).parent().removeClass("hovered");
          $(this).removeAttr("open", "open");
          $(this).children("summary").removeAttr("aria-expanded", "true");
        }
      );
    } else {
      $("details").off("mouseenter mouseleave");
    }
  }
  DesktopMenu();

  $(window).resize(DesktopMenu);

  $(".testimonials-sec .slider-wrapper").slick({
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".about-product-slider-sec .slider-wrapper").slick({
    dots: true,
    infinite: true,
    speed: 1200,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  document.addEventListener("DOMContentLoaded", function () {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      document.body.classList.add("safari-only");
    }
  });
});
